/*
 * @Author       : suzhen
 * @Email        : suzhen@dianzhong.com
 * @Date         : 2022-09-19 11:42:43
 * @LastEditors: suzhen@dainzhong.com
 * @LastEditTime: 2026-03-03 16:25:21
 * @Description  : 接口请求封装
 */
import axios from "axios";
import { getUserId, getStorage, removeUserId } from '@/utils/cookie.js'
import { os, getVs, h5Log, projectVersion } from '@/utils'
import { showToast } from 'vant';
import router from "@/router/index.js";
axios.defaults.baseURL = '/api/'

//post请求头
axios.defaults.headers.post["Content-Type"] = "application/json"
//设置超时
axios.defaults.timeout = 60000

axios.interceptors.request.use(
	config => {
		return config;
	},
	error => {
		return Promise.reject(error)
	}
);

// axios.interceptors.response.use(
//   response => {
//     if (response.status == 200) {
//       return Promise.resolve(response)
//     } else {
//       return Promise.reject(response)
//     }
//   },
//   error => {
//     console.log(error)
//   }
// );

export const cancelFnMap = new Map()

function headerComputed() {
	let setQuery = getStorage('readQuery', true) || {}
	let headers = {
		'Content-Type': 'application/json; charset=utf-8',
		'domain': '19',
		'userId': getUserId() || window.sessionStorage.getItem('payid') || '',
		'pname': 'com.dz.h5video',
		'utdid': getStorage('utdid'),
		'oid': getStorage('hoid'),
		'os': os(),
		'appid': 'koc',
		'channelCode': setQuery.channelId || '',
		'referral_id': setQuery.referral_id || '',
		'from': setQuery.from || '',
		'path': location.host || '',
		'mark': setQuery.mark || '',
		'pushId': setQuery.push_id || '',
		'pushIdx': setQuery.push_idx || '',
		'pushTime': setQuery.push_time || '',
		'ver': getVs(),
		'version': projectVersion,
	}
	return headers
}

export default {
	post(url, data, header = {}, isCancel = false) {
		const CancelToken = axios.CancelToken;  
 
		return new Promise((resolve, reject) => {
			// h5Log('request', 'start', 'event', {url, data, headers: headerComputed()})
			axios({
				method: 'POST',
				url,
				data: data,
				headers: {
					token: getUserId(),
					...header,
					version: projectVersion
				},
				cancelToken: new CancelToken(cancelFn => {
					// executor 函数接收一个 cancel 函数作为参数
					if (isCancel) {
						cancelFnMap.set(url, cancelFn)
					}
				})
			})
				.then(res => {
					// res.data.code = 10000
					if (res && res.data && res.data.code == 0) {
						resolve(res.data.data || true)
					// ----------------服务关停-----------------------
					} else if (res && res.data && res.data.code == 10000) {
							router.replace('/home?un_server=1')
					// ----------------服务关停-----------------------
					} else {
						// 统一处理错误类型的码
						showToast({ message: res && res.data.msg || '未知错误', position: 'top' })
						// showToast(res && res.data.msg|| '未知错误')
						if (res && res.data && res.data.code == 1111) {
							removeUserId()
							window.location.replace('/login')
						}
						reject(res && res.data || {})
						h5Log('request', 'fail_data', 'event', { url, ...res })
					}
				}, (err) => {
					console.log(err)
					// 如果是取消请求的错误，不做重试
					if (axios.isCancel(err) && isCancel) return
					this.doubelAxios(url, data, header = {}, resolve, reject)
				})
				.catch(err => {
					reject(err)
					h5Log('request', 'fail_server', 'event', { url, err })
				})
				.finally(() => {
					if (isCancel) {
						cancelFnMap.delete(url)
					}
				})
		})
	},

	doubelAxios(url, data, header = {}, resolve, reject) {
		axios({
			method: 'POST',
			url,
			data: data,
			headers: {
				token: getUserId(),
				...header,
				version: projectVersion
			}
		})
			.then(res => {
				if (res && res.data && res.data.code == 0) {
					h5Log('request', 'success_server', 'event', { url, qtime: '2' })
					resolve(res.data.data || true)
				} else {
					reject({})
					h5Log('request', 'fail_server', 'event', { url, qtime: '2', ...data, resCode: '!0' })
				}
			}, () => {
				h5Log('request', 'fail_server', 'event', { url, qtime: '2', ...data, resCode: 'err' })
				reject()
			})
	},

	get(url, data, isCancel = false) {
		const CancelToken = axios.CancelToken;  

		return new Promise((resolve, reject) => {
			axios({
				method: 'GET',
				headers: headerComputed(),
				url,
				params: data,
				cancelToken: new CancelToken(cancelFn => {
					// executor 函数接收一个 cancel 函数作为参数
					if (isCancel) {
						cancelFnMap.set(url, cancelFn)
					}
				})
			}).then(res => {
				resolve(res.data)
			}, err => {
				reject(err)
			})
			.catch(err => {
				reject(err)
			})
			.finally(() => {
				if (isCancel) {
					cancelFnMap.delete(url)
				}
			})
		})
	}
}
